import type { OrchestratedQuote } from '@b-stock/fe-core/bstock-next/queries'
import { TmsErrorCode } from '@b-stock/shipment-api-client'

import { getParcelZeroQuoteCode } from '@/buyer-portal/components/ParcelRateList/detectNoRates'
import { PARCEL_NO_RATES_MESSAGE_KEYS } from '@/buyer-portal/components/ParcelRateList/types'

/**
 * Message id for the listing page's zero-quote banner. A parcel zero-quote
 * gets the same reason as the Bid and Buy Now pop-ups; any other zero-quote
 * gets the general "couldn't get the shipping fee" text.
 */
export const getZeroQuoteBannerMessageId = (
  quote: OrchestratedQuote | null | undefined
): string => {
  const parcelCode = getParcelZeroQuoteCode(quote)
  if (parcelCode) return PARCEL_NO_RATES_MESSAGE_KEYS[parcelCode]

  const isTMSError =
    quote?.tmsMetaData?.errorCode === TmsErrorCode.TmsUnavailable
  return `Listing.actionColumn.payment.noRates.${isTMSError ? '3gDown' : 'other'}`
}
